let btnRegisterSubmit = document.getElementById("register-submit");
if(btnRegisterSubmit) document.getElementById("register-submit").disabled = true;
document.getElementById("OtpCode").style.display = "none";

let timerOn = true;

function timer(remaining) {
  var m = Math.floor(remaining / 60);
  var s = remaining % 60;
  
  m = m < 10 ? '0' + m : m;
  s = s < 10 ? '0' + s : s;
  document.getElementById('countdown').innerHTML = m + ':' + s;
  remaining -= 1;
  
  if(remaining >= 0 && timerOn) {
    setTimeout(function() {
      timer(remaining);
    }, 1000);
    return;
  }

  if(!timerOn) {
    // Do validate stuff here
    return;
  }
  
  document.getElementById("message-send-otp").innerHTML = "Your OTP code is expired";
  document.querySelectorAll("#buttonOtp a.btn").forEach((el) => {
    el.classList.remove("disabled")
  })
}

// DISABLE OTP BUTTON
let inputEmail = document.getElementById("Email");
let inputPhone = document.getElementById("PhoneNumber");
// let buttonEmail = document.getElementById("otpEmail");
let buttonSms = document.getElementById("otpSms");
let buttonWa = document.getElementById("otpWa");
let regexPhoneNumber = /^(?:\+62|62|0)[2-9]{1}[0-9]{7,11}$/;

inputPhone.addEventListener("keyup", ()=> {
  if(!regexPhoneNumber.test(inputPhone.value)) {
    buttonSms.classList.add("disabled");
    buttonWa?.classList.add("disabled");
    document.getElementById("OtpCode").style.display = "none";
  } else {
    buttonSms.classList.remove("disabled");
    buttonWa?.classList.remove("disabled");
    document.getElementById("OtpCode").style.display = "block";
  }
});

// GET OTP
function sendOtp(type) {
  document.getElementById("OtpCode").setAttribute("data-type", type);
  let regexPhoneNumber = /^(?:\+62|62|0)[2-9]{1}[0-9]{7,11}$/;
  let emailVal = document.getElementById("Email").value;
  
  if(type == "email") {
    let buttonEmail = document.getElementById("otpEmail");
    
    let formData = {
      type: type,
      email: emailVal
    }

    validateEmail(emailVal);
    if(validateEmail) {
      buttonEmail.classList.add("btn--loading");
      document.getElementById("otpSms").classList.add("disabled");
      document.getElementById("otpWa").classList.add("disabled");
      getOtp(formData, "Please check your email to see OTP code", "otpEmail");
    }
    
  } else if(type == "sms") {
    let phoneVal = document.getElementById("PhoneNumber").value;
    let buttonSms = document.getElementById("otpSms");

    document.getElementById('countdown').innerHTML = "";

    if(regexPhoneNumber.test(phoneVal)) {
      let formData = {
        type: type,
        phone: phoneVal,
        email: emailVal
      }
  
      buttonSms.classList.add("btn--loading");
      // document.getElementById("otpEmail").classList.add("disabled");
      // document.getElementById("otpWa").classList.add("disabled");
      getOtp(formData, "Please check your phone to get OTP code", "otpSms");
    } else {
      document.getElementById("message-phone-number").innerHTML = "Please input the valid phone number";
    }
    
  } else if(type == "whatsapp") {
    let phoneVal = document.getElementById("PhoneNumber").value;
    let buttonWa = document.getElementById("otpWa");

    if(regexPhoneNumber.test(phoneVal)) {
      let formData = {
        type: type,
        phone: phoneVal,
        email: emailVal
      }
  
      buttonWa.classList.add("btn--loading");
      // document.getElementById("otpEmail").classList.add("disabled");
      document.getElementById("otpSms").classList.add("disabled");
      getOtp(formData, "Please check your phone to get OTP code", "otpWa");
    } else {
      document.getElementById("message-phone-number").innerHTML = "Please input the valid phone number";
    }
  }
}

function getOtp(data, message, id){
  document.getElementById("message-phone-number").innerHTML = "";
  fetch('https://aba-v2-6k5ud3a4.an.gateway.dev/otp', {
    method: 'POST',
    mode: "cors",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': 'AIzaSyDHVX-dHdJ25PBQIbmsDpfdbnAQwGsYtUU'
    },
    body: JSON.stringify(data)
  })
  .then((response) => {
    let status = response.status;
    if(status == 200){
      document.getElementById(id).classList.remove("btn--loading");
      document.querySelectorAll("#buttonOtp a.btn").forEach((el) => {
        el.classList.add("disabled")
      })
      document.getElementById("message-send-otp").innerHTML = message;
      timer(60);
    }

    if(status == 409){
      document.getElementById(id).classList.remove("btn--loading");
      document.querySelectorAll("#buttonOtp a.btn").forEach((el) => {
        el.classList.remove("disabled")
      })
      document.getElementById("message-phone-number").innerHTML = "Your phone number already registered. Please enter another phone number.";
    }
    
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// VERIFY OTP
const debounce = (func, delay) => {
  let debounceTimer
  return function() {
    const context = this
    const args = arguments
    
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => func.apply(context, args), delay)
  }
}

let inputOtpCode = document.getElementById("OtpCode");
inputOtpCode.addEventListener("keyup", debounce(function() {
  let typeOtp = inputOtpCode.getAttribute("data-type");
  let otpCode = inputOtpCode.value;

  if(typeOtp == "email") {
    let emailVal = document.getElementById("Email").value;

    let data = {
      type: typeOtp,
      email: emailVal,
      otp: otpCode
    }

    verifyOtp(data)
  } else if(typeOtp == "sms"){
    let phoneVal = document.getElementById("PhoneNumber").value;

    let data = {
      type: typeOtp,
      phone: phoneVal,
      otp: otpCode
    }

    verifyOtp(data)
  } else if(typeOtp == "whatsapp"){
    let phoneVal = document.getElementById("PhoneNumber").value;

    let data = {
      type: typeOtp,
      phone: phoneVal,
      otp: otpCode
    }

    verifyOtp(data)
  }
}, 900));

function verifyOtp(data) {
  document.getElementById("message-send-otp").innerHTML = "Loading...";
  document.getElementById("message-result-otp").innerHTML = "";
  fetch('https://aba-v2-6k5ud3a4.an.gateway.dev/otp/verify', {
    method: 'POST',
    mode: "cors",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': 'AIzaSyDHVX-dHdJ25PBQIbmsDpfdbnAQwGsYtUU'
    },
    body: JSON.stringify(data)
  })
  .then((response) => {
    if(response.status == 200){
      document.getElementById("message-send-otp").innerHTML = "";
      document.getElementById("message-result-otp").innerHTML = "";
      document.getElementById("message-verify-otp").innerHTML = "OTP verified, you can continue to register your account";

      let tncCheckbox = document.querySelector(".accepts-tnc input[type='checkbox']");
      if(tncCheckbox.checked) {
        if(document.getElementById("Year").value !== "") {
          if(btnRegisterSubmit) document.getElementById("register-submit").disabled = false;
        }
        document.getElementById("Year").addEventListener("change", (e)=> {
          const selected = e.target.options[e.target.selectedIndex];
          if (selected.value !== "") {
            document.getElementById("register-submit").disabled = false;
          }
        })
      } else {
        tncCheckbox.addEventListener("change", ()=> {
          if(tncCheckbox.checked){
            document.getElementById("accepts-tnc").value = true;
            if(document.getElementById("Year").value !== "") {
              if(btnRegisterSubmit) document.getElementById("register-submit").disabled = false;
            }
            document.getElementById("Year").addEventListener("change", (e)=> {
              const selected = e.target.options[e.target.selectedIndex];
              if (selected.value !== "") {
                document.getElementById("register-submit").disabled = false;
              }
            })
          } else {
            document.getElementById("accepts-tnc").value = false;
            if(btnRegisterSubmit) document.getElementById("register-submit").disabled = true;
          }
        })
      }
    }
  
    if(response.status == 404){
      document.getElementById("message-send-otp").innerHTML = "";
      document.getElementById("message-result-otp").innerHTML = "OTP verification failed";
    }
    
    return response.json();
  })
  .then((result) => {
    console.log(result)
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function validateEmail(inputEmail) {
  let mailFormat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  if(!inputEmail.match(mailFormat)) {
    alert("Invalid email address");
    return false;
  }

  return true;
}

document.querySelectorAll(".input-full:not(#Email)").forEach(el => {
  el.setAttribute("disabled", "disabled");
})

function verifyUser() {
  let email = inputEmail.value;
  let emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  let message = document.getElementById("message-verify-user");

  if (email.match(emailPattern)) {
    fetch('https://asia-southeast2-aba-id.cloudfunctions.net/verifyUser', {
      method: 'POST',
      mode: "cors",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email: email})
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      message.textContent = "";
      if(result.email) {
        result.is_active ? message.classList.add("message__text-error") : message.classList.add("message__text")
        message.textContent = result.message;

        document.querySelectorAll(".input-full:not(#Email)").forEach(el => {
          el.disabled = true;
        })
      } else {
        // message.classList.add("message__text-error")
        // message.textContent = result.message;
        const urlParam = new URLSearchParams(window.location.search);
        const kodeStoreOdoo = urlParam.get('store'); 
        if(kodeStoreOdoo && kodeStoreOdoo != '') {
          document.querySelectorAll(".input-full:not(#Email)").forEach(el => {
            el.classList.contains("store_list") ? el.disabled = true : el.disabled = false;
          })
        } else {
          document.querySelectorAll(".input-full:not(#Email)").forEach(el => {
            el.disabled = false;
          })
        }
      }
      console.log(result)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } else {
    message.classList.add("message__text-error");
    message.textContent = "Invalid email address";
  }

  if (email === "") {
    message.textContent = "";
    document.querySelector(".personal-information__wrapper").style.paddingTop = "30px";
    document.querySelectorAll(".input-full:not(#Email)").forEach(el => {
      el.disabled = true;
    })
  }
}

inputEmail.addEventListener("input", debounce(verifyUser, 1000));